import React from 'react';
import { MediaContainer } from './CardMedia.styles';
import Image from '@/providers/Image';
import Link from '@/providers/Link';
import useImagePulse from '@/components/image/imagePulseHook';
import { AssetUrlCdnPathType, mediaBlurDataUrl, mediaUrlCdn } from '@/utils/media';

export interface CardMediaProps {
  href?: string;
  media: MediaObjType[];
  minHeight?: number | string;
  minHeightMobile?: number | string;
  priority?: boolean;
  mediaOptions?: AssetUrlCdnPathType['options'];
}

const CardMedia = ({
  href,
  media,
  minHeight = 168,
  minHeightMobile,
  priority,
  mediaOptions,
  ...props
}: CardMediaProps) => {
  const { className, containerRef, handleOnCompleted } = useImagePulse();

  if (!media) {
    media = [];
  }
  const title = media[0]?.title || 'Foto ilustrativa';
  const imageUrl = mediaUrlCdn({ media: media[0], options: { ...mediaOptions } });
  const imageBlurDataUrl = mediaBlurDataUrl({ media: media[0] });

  return (
    <MediaContainer
      minHeight={minHeight}
      minHeightMobile={minHeight}
      className={className}
      ref={containerRef}
      {...props}
    >
      {(href && (
        <Link href={href}>
          <Image
            src={imageUrl}
            alt={title}
            fill
            placeholder={imageBlurDataUrl}
            fadeInOnBlur
            handleOnCompleted={handleOnCompleted}
            priority={priority}
          />
        </Link>
      )) || <Image src={`${imageUrl}`} alt="" fill priority={false} />}
    </MediaContainer>
  );
};

export default CardMedia;
